// src/api/cases.js
import client from './client.js';

export const casesAPI = {
  getAll: (params) => client.get('/cases', { params }),
  getById: (id) => client.get(`/cases/${id}`),
  create: (data) => client.post('/cases', data),
  update: (id, data) => client.put(`/cases/${id}`, data),
  delete: (id) => client.delete(`/cases/${id}`),
};